import React from "react"
import PropTypes from "prop-types"
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import Card from "./card"

class SkipSizes extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      phoneNumber: props.phoneNumber,
      isLoading: true,

      skips: [{
        title: "Small",
        usps: [
          { text: "Home DIY projects" },
          { text: "Large building extensions" },
          { text: "House clearance" },
          { text: "Garden projects" },
          { text: "Waste building materials" }
        ],
        sizes: [{
          title: "Mini Skip",
          size: "2 Cubic Yard / 35 Bin Bags",
          skipWidth: "w-32",
          tip: "W 1.29m x H 0.97m x L 1.83m",
          featured: false
        }, {
          title: "Midi Skip",
          size: "4 Cubic Yard / 50 Bin Bags",
          skipWidth: "w-40",
          tip: "W 1.29m x H 0.97m x L 1.83m",
          featured: true
        }, {
          title: "Large Midi Skip",
          size: "6 Cubic Yard / 75 Bin Bags",
          skipWidth: "w-48",
          tip: "W 1.29m x H 0.97m x L 1.83m",
          featured: false
        }]
      },{
        title: "Medium",
        usps: [
          { text: "Home extensions" },
          { text: "Driveway waste (paving slabs, rock & rubble)" },
          { text: "Landscape clearance" },
          { text: "House clearance" }
        ],
        sizes: [{
          title: "Medium Builders Skip",
          size: "8 Cubic Yard / 90 Bin Bags",
          skipWidth: "w-32",
          tip: "W 1.29m x H 0.97m x L 1.83m",
          featured: false
        }, {
          title: "Large Builders / Maxi Skip",
          size: "12 Cubic Yard / 100 Bin Bags",
          skipWidth: "w-40",
          tip: "W 1.29m x H 0.97m x L 1.83m",
          featured: true
        }, {
          title: "Large / Maxi Skip",
          size: "14 Cubic Yard / 160 Bin Bags",
          skipWidth: "w-48",
          tip: "W 1.29m x H 0.97m x L 1.83m",
          featured: false
        }]
      },{
        title: "Large",
        usps: [
          { text: "Large quanities of bricks, blocks, concrete or soil" },
          { text: "General mixed non-hazardous waste" },
          { text: "Packaging, timber, plastics" },
          { text: "Light bulky waste" }
        ],
        sizes: [{
          title: "Roll On Roll Off",
          size: "20-40 Cubic Yard",
          skipWidth: "w-48",
          tip: "W 1.29m x H 0.97m x L 1.83m",
          featured: true
        }]
      }]
    };
  }

  componentDidMount() {
  }
  
  render() {
    return (
      <div className="mb-16 lg:mb-32">
        <Tabs>
          <TabList className="flex flex-wrap items-center justify-center">
            {this.state.skips.map((skip =>
              <Tab key={skip.title}>
                {skip.title} <span className="md:block font-normal leading-snug text-lg">Projects</span>
              </Tab> 
            ))}
          </TabList>

          <div className="bg-grey-light py-10 pb-0 md:py-16 md:pb-12 lg:py-24 lg:pb-18">
            {this.state.skips.map((skip =>
              <TabPanel>
                <div className="container xl:px-12 2xl:px-32">
                  <ul className="flex flex-wrap justify-center max-w-5xl mx-auto mb-6 md:mb-12 lg:mb-16 text-center">
                    {skip.usps.map((usp, index) =>
                      <li key={index} className="text-base sm:text-lg md:text-xl mb-2 mx-6"><FontAwesomeIcon className="text-primary text-lg mr-2" icon="check" /> {usp.text}</li>
                    )}
                  </ul>
                  
                  <div className="overflow-hidden max-w-1/2">
                    <div className="flex flex-wrap justify-center md:-mx-8 xl:-mx-12 p-5">
                      {skip.sizes.map((size, index) =>
                        <div key={index} className="w-full md:w-1/2 mb-12 xl:mb-0 xl:w-1/3 md:px-8 xl:px-12">
                          <Card
                            title={size.title}
                            size={size.size}
                            skipWidth={size.skipWidth}
                            featured={size.featured}
                            tip={size.tip}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </TabPanel>
            ))}
          </div>
        </Tabs>
        <div className="bg-grey-light pb-12 md:pb-24">
          <div className="container text-center">
            <p className="text-xl md:text-2xl">Call <a className="font-bold transition hover:text-primary focus:text-primary" href={`tel:${this.state.phoneNumber}`}>{this.state.phoneNumber}</a> or <a href="#quote" className="btn btn--alt block mt-2 sm:mt-0 sm:inline-block">Get a Quote</a></p>
          </div>
        </div>
      </div>
    );
  }
}

SkipSizes.propTypes = {
  phoneNumber: PropTypes.string,
}

SkipSizes.defaultProps = {
  phoneNumber: ``,
}

export default SkipSizes;